import Alpine from "alpinejs";
import Swiper, { Scrollbar } from "swiper";

Alpine.data("swiper", (maxSlides) => ({
    options: {
        modules: [Scrollbar],
        scrollbar: {
            el: ".js-edgeslider-scrollbar",
            draggable: true,
        },
        slidesPerView: "auto",
        spaceBetween: 16,
        breakpoints: {
            375: {
                slidesPerView: Math.max(1.05, (375 / 1184) * maxSlides),
            },
            475: {
                slidesPerView: Math.max(1.1, (475 / 1184) * maxSlides),
            },
            640: {
                slidesPerView: Math.max(1.1, (640 / 1184) * maxSlides),
                spaceBetween: 24,
            },
            768: {
                slidesPerView: Math.max(1.1, (768 / 1184) * maxSlides),
            },
            860: {
                slidesPerView: Math.max(1.1, (860 / 1184) * maxSlides),
            },
            1024: {
                slidesPerView: Math.max(1.1, (1024 / 1184) * maxSlides),
            },
            1184: {
                slidesPerView: maxSlides,
                spaceBetween: 32,
            },
        },
    },
    init() {
        this.$nextTick(() => {
            new Swiper(this.$el, this.options);
        });
    },
}));
